import {FmlxIcon, FmlxTooltip, FmlxComboBox} from 'fmlx-common-ui';
import {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {updateSDReplicateWell} from 'stores/business/taskListSerialDilutionBusiness';
import {useIntl} from 'react-intl';
import {getFirstSelectedCardSelector} from 'stores/selectors/cardStateSelector';
import {setSdReplicateWell} from 'stores/actions/cardSerialDilutionStateAction';
import {showSnackbar} from 'stores/actions/appStateAction';
import {Feedback} from 'constants/dataEnum';

const replicateWellsOptions = new Array(24).fill(1).map((el, index) => ({
  id: index + 1,
  text: index === 0 ? '-' : index + 1,
  group: '',
}));

function ReplicateWellOption() {
  const [selectedItem, setSelectedItem] = useState(null);
  const dispatch = useDispatch();
  const intl = useIntl();
  const selectedCard = useSelector(getFirstSelectedCardSelector);

  const isReplicateWellDisabled = useMemo(() => {
    const {step} = selectedCard.sdProperty;
    const {taskSampleSource, taskSampleTarget, taskDiluentTargets} = selectedCard.sdRawTasksSummary;

    const isNoSamplePatternEstablished = !taskSampleSource && !taskSampleTarget.length;
    const isMultiQuadrantPattern = taskSampleTarget?.length > 1 || (step || 0) !== taskDiluentTargets.length;

    return isNoSamplePatternEstablished || isMultiQuadrantPattern;
  }, [selectedCard.sdProperty, selectedCard.sdRawTasksSummary]);

  useEffect(() => {
    if (isReplicateWellDisabled && selectedCard?.sdProperty.replicateWell !== 1) {
      dispatch(setSdReplicateWell(selectedCard.ID, 1));
    }
  }, [dispatch, isReplicateWellDisabled, selectedCard.ID, selectedCard?.sdProperty.replicateWell]);

  useEffect(() => {
    setSelectedItem({
      id: selectedCard?.sdProperty.replicateWell,
      text: selectedCard?.sdProperty.replicateWell === 1 ? '-' : selectedCard?.sdProperty.replicateWell,
    });
  }, [selectedCard?.sdProperty.replicateWell]);

  const handleChange = (item) => {
    setSelectedItem(item);
    dispatch(updateSDReplicateWell(item.id));
    dispatch(
      showSnackbar(Feedback.INFO, intl.formatMessage({id: 'protocolEditor.serialDilution.replicateWells.countUpdate'})),
    );
  };

  return (
    <div className="replicate-wells">
      <FmlxTooltip
        placement="bottom"
        title={intl.formatMessage({id: 'protocolEditor.serialDilution.replicateWells.helpTooltip'})}
      >
        <div>
          <FmlxIcon name="HelpCircle" size="sm" />
        </div>
      </FmlxTooltip>
      <p className="replicate-wells__label">
        {intl.formatMessage({id: 'protocolEditor.serialDilution.replicateWells.lable'})}
      </p>
      <div className="replicate-wells__options">
        <FmlxComboBox
          placeholder="-"
          items={replicateWellsOptions}
          selectedItem={selectedItem}
          onChange={handleChange}
          size="sm"
          disabled={isReplicateWellDisabled}
        />
      </div>
    </div>
  );
}

export default ReplicateWellOption;
